export default __webpack_public_path__ + "static/media/LA_US.fb0783b4.jpg";